import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";

const InstructorListData = () => {
  const [instructorData, setInstructorData] = useState({
    forum: 0,
    thisMonthForum: 0,
  });

  const fetch = () => {
    axiosInstance
      .get("instructor/statistics")
      .then(({ data: { data: instructorData } }) => {
        setInstructorData((state) => ({ ...state, ...instructorData }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <div className="flex-dashboard-new">
        <div className={`box-shadow-05 Dashboard-color-one`}>
          <p className="font-custom-p">Courses</p>
          {instructorData.hasOwnProperty("courses") ? (
            <span className={`font-increase color-one`}>
              {instructorData.courses}
            </span>
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
          <div className="dashboard-main-new">
            <p className="this-month-style">This Month</p>
            <p className={` color-one flex-text-one`}>
              {instructorData?.thisMonthCourses}
            </p>
          </div>
        </div>

        <div className={`box-shadow-05 Dashboard-color-two`}>
          <p className="font-custom-p">Complete Webinars</p>
          {instructorData.hasOwnProperty("completedWebinars") ? (
            <span className={`font-increase color-one`}>
              {instructorData.completedWebinars}
            </span>
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}

          <div className="dashboard-main-new">
            <p className="this-month-style">This Month</p>
            <p className={` color-two flex-text-one`}>
              {instructorData?.thisMonthCompletedWebinars}
            </p>
          </div>
        </div>

        <div className={`box-shadow-05 Dashboard-color-three`}>
          <h4 className="font-custom-p">Students</h4>
          {instructorData.hasOwnProperty("students") ? (
            <span className={`font-increase color-one`}>
              {instructorData.students}
            </span>
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}

          <div className="dashboard-main-new">
            <p className="this-month-style">This Month</p>
            <p className={` color-three flex-text-one`}>
              {instructorData?.thisMonthStudents}
            </p>
          </div>
        </div>

        <div className={`box-shadow-05 Dashboard-color-four`}>
          <p className="font-custom-p">Forum Question</p>
          {instructorData.hasOwnProperty("forum") ? (
            <span className={`font-increase color-one`}>
              {instructorData.forum}
            </span>
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
          <div className="dashboard-main-new">
            <p className="this-month-style">This Month</p>
            <p className={` color-four flex-text-one`}>
              {instructorData?.thisMonthForum}
            </p>
          </div>
        </div>

        <div className={`box-shadow-05 Dashboard-color-five`}>
          <p className="font-custom-p">Certificates</p>
          {instructorData.hasOwnProperty("certificates") ? (
            <span className={`font-increase color-one`}>
              {instructorData.certificates}
            </span>
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
          <div className="dashboard-main-new">
            <p className="this-month-style">This Month</p>
            <p className={` color-five flex-text-one`}>
              {instructorData?.thisMonthCertificates}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorListData;
